module.exports = "\n<div class=\"container\">\n  <div class=\"page-header\">\n    <h1>添加</h1>\n  </div>\n  <div>\n    <form>\n\n      <div class=\"form-group\">\n        <label for=\"name\">组名</label>\n        <input type=\"name\" class=\"form-control\" ng-model=\"betagroupsAddCtrl.newGroup.name\" required>\n      </div>\n\n      <button type=\"submit\" class=\"btn btn-success\" ng-click=\"betagroupsAddCtrl.save()\">保存</button>\n    </form>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/betagroups/add/add.html
// module id = 297
// module chunks = 0